/*
 * A custom error type for errors coming from the task manager.
 * These errors will have errors stored in this.errors, which allows
 * us to batch errors from several handlers into one exception.
 */
function TaskManagerError(message, errors) {
  this.name = 'TaskManagerError';
  this.message = message;
  this.errors = errors;
  this.getFirstErrorOfType = type => {
    let result;
    this.errors.some(error => {
      if (error instanceof TaskManagerError.prototype.constructor) {
        result = error.getFirstErrorOfType(type);
        return !!result;
      }
      if (error instanceof type) {
        result = error;
        return true;
      }
      return false;
    });
    return result;
  };
  // Similar to Array.some this tests whether any Errors aggregated by TaskManager
  // match the provided Error type and message
  this.some = (type, msg) => {
    return this.errors.some(error => {
      if (error instanceof type && error.message === msg) {
        return true;
      }
      return false;
    });
  };
}

TaskManagerError.prototype = new Error();
TaskManagerError.prototype.constructor = TaskManagerError;

export function isInstanceOf(error, type) {
  if (error instanceof type) return true;
  if (error instanceof TaskManagerError) {
    if (error.getFirstErrorOfType(type)) return true;
  }
  return false;
}

export function extractError(error, type) {
  if (error instanceof TaskManagerError) {
    return error.getFirstErrorOfType(type);
  }
  return error;
}

export default TaskManagerError;
